import { i18n } from '@/i18n.js'
import { router } from '@/router/index.js'
import { tokenStore } from '@/stores/tokenStore.js'
import { translationStore } from '@/stores/translationStore.js'

export const API = {
  throwError() {
    const tokStore = tokenStore()
    tokStore.clearToken()
    router.push({
      name: 'ErrorPage',
      query: {
        errorMsg: 'errorOccured',
        errorText: 'Unauthorized',
        errorCode: '401'
      },
      params: { pathMatch: 'errorToken' }
    })
  },
  timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  },
  async request(typeRequest, url, queryParams = null, body = null) {
    const tokStore = tokenStore()
    try {
      for (let claim in ['urlApi', 'scope']) {
        if(!(claim in Object.keys(tokStore.payload))) {
          this.throwError()
        }
      }
    } catch (e) {
      this.throwError()
    }

    if (tokStore.currentToken != null) {
      url = url.replace('api/', '')
      let newUrl = new URL(tokStore.payload.urlApi + '/api/data-capture/' + url)
      
      if (queryParams !== null) {
        // If query parameters are sent, we create a new URLSearchParams and give it to newUrl
        newUrl.search = new URLSearchParams(queryParams)
      }

      // Define the default header
      let headers = new Headers()
      headers.append('Accept', 'application/json')
      headers.append('x-public-token', tokStore.currentToken)
      headers.append('lang', i18n.locale && i18n.locale.split('-')[0] ? i18n.locale.split('-')[0] : 'fr')
      headers.append('country', i18n.locale && i18n.locale.split('-')[1] ? i18n.locale.split('-')[1] : 'fr')
      headers.append(
        'storeExternalId',
        tokStore.payload?.storeExternalId ? tokStore.payload.storeExternalId : ''
      )
      headers.append(
        'idSeller',
        tokStore.payload?.idSeller ? tokStore.payload.idSeller : ''
      )
      
      if(body) {
        body = JSON.stringify(body)
        headers.append('Content-Type', 'application/json')
      }

      let failedAttempts = 0
      let initFetch = {
        method: typeRequest,
        headers: headers,
        body: body
      }
      let result = null
      
      try {
        while (failedAttempts <= 3) {
          result = await fetch(newUrl, initFetch).catch(e => {
            if(failedAttempts === 3) throw e
            failedAttempts++
          })
          if (result) break
        }
      } catch(e) {
        throwError()
      }

      if(result.ok) {
        return result.json()
      } else {
        return result
      }
    }
  },
  /**
   * Get the translations from the API
   */
  async getTranslations() {
    let translations = await this.request('GET', 'api/translations', null, null, false)
    translationStore().setAppTranslation(translations)
    return translations
  }
}
